import React, { useEffect, useState } from "react";
import "../../styles/update/dashboard.css";
import { useAppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import supabase from "../../lib/supabase";
import ClientMessages from "./ClientMessages";
import Projects from "./Projects";
import DirectChat from "./DirectChat";

export default function Dashboard() {
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState("messages");
  const { logout } = useAppContext();

  const logoutUser = async () => {
    try {
      await logout?.();
      navigate("/", { replace: true });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  return (
    <div className="dashboard">
      <div className="dash-header">
        <h2>Dashboard</h2>
        <button onClick={logoutUser}>Logout</button>
      </div>
      <div className="content">
        <div className="sidebar">
          <ul>
            <li
              className={activeComponent === "messages" ? "active" : ""}
              onClick={() => setActiveComponent("messages")}
            >
              📩 Client Messages
            </li>
            <li
              className={activeComponent === "projects" ? "active" : ""}
              onClick={() => setActiveComponent("projects")}
            >
              🗂 Projects
            </li>
            <li
              className={activeComponent === "updateProfile" ? "active" : ""}
              onClick={() => setActiveComponent("updateProfile")}
            >
              👤 Update Profile
            </li>
            <li
              className={
                activeComponent === "pushNotifications" ? "active" : ""
              }
              onClick={() => setActiveComponent("pushNotifications")}
            >
              🔔 Send Push Notifications
            </li>
          </ul>
        </div>
        <div className="main">
          {activeComponent === "messages" ? (
            <ClientMessages />
          ) : activeComponent === "projects" ? (
            <Projects />
          ) : activeComponent === "updateProfile" ? (
            <UpdateProfile />
          ) : (
            <DirectChat />
          )}
        </div>
      </div>
    </div>
  );
}

const UpdateProfile = () => {
  return (
    <div>
      <p>ss</p>
    </div>
  );
};
